import * as React from 'react';
import { EditButton } from 'react-admin';
import ReplayIcon from "@mui/icons-material/Replay";

const ReprocessButton = () => {
    return <EditButton label="" icon={<ReplayIcon />} alignIcon="left" size="small" />;
};

export default ReprocessButton;